window.articleTeaser = {
    $teasers: null,

    init: function($elements) {
        this.$teasers = $elements;

        this.initializeToggleListener();
    },
    /**
     * Initialize Toggle Listener for hide/show Description
     */
    initializeToggleListener: function() {
        this.$teasers.forEach(function(item) {
            var $description = item.querySelector(".teaser__description"),
                $collapseIcon = item.querySelector(".teaser__collapse");

            $collapseIcon.addEventListener("click", function() {
                $description.classList.toggle("teaser__description--toggled");
                $collapseIcon.classList.toggle("teaser__collapse--toggled");
            });
        });
    },

    /**
     * hide All Descriptions
     */
    showOrHideDescription: function($articleItems, $state) {
        $articleItems.forEach(function(item) {
            var $description = item.querySelector(".teaser__description"),
                $collapseIcon = item.querySelector(".teaser__collapse");

            if($state === 'show') {
                $description.classList.remove('teaser__description--toggled');
                $collapseIcon.classList.remove('teaser__collapse--toggled');
            }
            else if ($state === 'hide') {
                $description.className += ' teaser__description--toggled';
                $collapseIcon.className += ' teaser__collapse--toggled';
            }
        });
    }
};
